var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldZapGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M9.88926 18.9141C10.083 19.0271 10.1798 19.0836 10.3165 19.1129C10.4226 19.1356 10.5774 19.1356 10.6835 19.1129C10.8202 19.0836 10.917 19.0271 11.1107 18.9141C12.8153 17.9196 17.5 14.7959 17.5 10.501V6.31645C17.5 5.61687 17.5 5.26709 17.3856 4.96641C17.2845 4.70079 17.1203 4.46379 16.907 4.27589C16.6657 4.06318 16.3382 3.94036 15.6831 3.69473L10.9916 1.93539C10.8097 1.86717 10.7187 1.83306 10.6251 1.81954C10.5421 1.80755 10.4579 1.80755 10.3749 1.81954C10.2813 1.83306 10.1903 1.86717 10.0084 1.93539L5.31685 3.69473C4.66182 3.94036 4.33431 4.06318 4.09295 4.27589C3.87973 4.46379 3.71549 4.70079 3.61442 4.96641C3.5 5.26709 3.5 5.61687 3.5 6.31645V10.501C3.5 14.7959 8.18472 17.9196 9.88926 18.9141Z",
    fill: "#4BA18A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 6.56159L8.75 9.18659L12.25 10.9366L9.625 13.5616M17.5 10.4991C17.5 14.794 12.8153 17.9177 11.1107 18.9121C10.917 19.0251 10.8202 19.0816 10.6835 19.1109C10.5774 19.1337 10.4226 19.1337 10.3165 19.1109C10.1798 19.0816 10.083 19.0251 9.88926 18.9121C8.18472 17.9177 3.5 14.794 3.5 10.4991V6.31449C3.5 5.61492 3.5 5.26514 3.61442 4.96446C3.71549 4.69884 3.87973 4.46184 4.09295 4.27393C4.33431 4.06123 4.66182 3.93841 5.31685 3.69277L10.0084 1.93343C10.1903 1.86522 10.2813 1.83111 10.3749 1.81759C10.4579 1.8056 10.5421 1.8056 10.6251 1.81759C10.7187 1.83111 10.8097 1.86522 10.9916 1.93343L15.6831 3.69277C16.3382 3.93841 16.6657 4.06123 16.907 4.27393C17.1203 4.46184 17.2845 4.69884 17.3856 4.96446C17.5 5.26514 17.5 5.61492 17.5 6.31449V10.4991Z",
    stroke: "#4BA18A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldZapGreen);
export default __webpack_public_path__ + "static/media/shield-zap-green.72707a94093a0116c51c4ea96b3c11a2.svg";
export { ForwardRef as ReactComponent };